import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { satelliteOpts } from '@satellite/plugins/vuetify.js';
import '@mdi/font/css/materialdesignicons.css';

import type { VuetifyOptions } from 'vuetify';

// const isSystemDarkModeEnabled =
//   typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches;
const isSystemDarkModeEnabled = false; // TODO: Do we want to automatically detect system setting?

const opts: VuetifyOptions = {
  ...satelliteOpts,
  defaults: {
    ...satelliteOpts.defaults,
    VTextField: {
      ...satelliteOpts.defaults?.VTextField,
      color: 'primary'
    }
  },
  theme: {
    ...satelliteOpts.theme,
    defaultTheme: isSystemDarkModeEnabled ? 'opendockThemeDark' : 'opendockTheme',
    themes: {
      ...(satelliteOpts.theme?.themes ?? {})
    }
  }
};

export default createVuetify(opts);
